<template lang="pug">
.container
  .information-filter.row.g-0.mb-5
    .col-md-5.d-flex.align-items-center.py-4.px-4
      label.flex-shrink-0.text-white.me-3 หน่วยงาน
      select(
        v-model='form.agency',
        @change='$router.push({ path: "/", query: { agency: decodeURIComponent(form.agency) } })'
      )
        option(value='', selected) ทั้งหมด
        option(
          v-for='agency in agencies',
          :key='agency.id',
          :value='decodeURIComponent(agency.slug)'
        ) {{ agency.name }}

    .col-md-7.d-flex.align-items-center.information-filter-keyword.bg-primary.py-4.px-4
      label.flex-shrink-0.text-white.me-3 ค้นหา
      input(type='search', v-model='form.keyword', @input='fetchInformation')

  .information-result(:class='{ "is-loading": isLoading }')
    .information-group.bg-light.d-flex.align-items-start.p-5.mb-5(
      v-for='(value, name, index) in informations',
      :key='index'
    )
      .information-date.d-flex.flex-column.justify-content-center.align-items-center.flex-shrink-0.bg-primary.rounded-1.text-white.me-4(
        v-html='$options.filters.dateFormat(name)'
      )
      .information-list.d-grid.gap-3.w-100
        .information-item.bg-white(
          v-for='information in value',
          :key='informations.id'
        )
          .d-flex
            .w-100.p-4
              h4.information-item-title.h5.fw-500.text-dark {{ information.title }}
              ul.d-flex.gap-3.list-unstyled.m-0.fs-14.text-dark
                li.pe-2 
                  span.pe-2 วันที่
                  span.text-primary {{ information.date }}
                li.pe-2(v-if='information.no')
                  span.pe-2 เลขที่
                  span {{ information.no }}
                li 
                  span.pe-2 หน่วยงาน
                  span {{ information.agency }}

            .information-item-action.d-flex.flex-column.flex-shrink-0.px-4.my-1.position-relative
              a.d-flex.align-items-center.h-50.text-decoration-none(
                :href='information.file',
                target='_blank'
              ) ดาวน์โหลด
              a.d-flex.align-items-center.h-50.text-decoration-none(
                :href='information.link',
                target='_blank'
              ) อ่านเพิ่มเติม
</template>

<script>
import axios from 'axios'
export default {
  filters: {
    dateFormat: (value) => {
      const values = value.split('-')
      return `<strong class="fs-80 lh-1 d-block">${values[0]}</strong> ${values[1]} ${values[2]}`
    },
  },
  data() {
    return {
      isLoading: false,
      informations: {},
      agencies: [],
      form: { agency: '' },
      meta: {
        total: 0,
      },
      page: 1,
    }
  },

  watch: {
    $route() {
      this.fetchInformation()
    },
  },

  created() {
    this.form.agency = this.$route.query.agency ?? ''
    this.fetchInformation()
    this.fetchAgencies()
  },

  methods: {
    fetchAgencies() {
      axios
        .get(`${PEA.api.url}wp/v2/information_agency`, {})
        .then(({ data }) => {
          this.agencies = data
        })
    },
    fetchInformation() {
      this.isLoading = true

      axios
        .get(`${PEA.api.url}v1/information`, {
          params: {
            agency: this.$route.query.agency,
            keyword: this.form.keyword,
          },
        })
        .then(({ data }) => {
          this.isLoading = false

          this.informations = data.data.reduce((result, currentValue) => {
            ;(result[currentValue.key] = result[currentValue.key] || []).push(
              currentValue
            )
            return result
          }, {})
        })
    },
  },
}
</script>

<style lang="scss">
.information {
  &-result {
    transition: opacity 0.2s;

    &.is-loading {
      opacity: 0.5;
    }
  }

  &-date {
    width: 8.75rem;
    height: 8.75rem;
  }

  &-item {
    box-shadow: 2px 4px 16px 1px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0px 0px 40px 1px #ecdaec;
    }

    &-action {
      border-left: #eaeaea solid 1px;

      &::after {
        position: absolute;
        top: 50%;
        left: 2px;
        right: 2px;
        height: 1px;
        content: '';
        background: #eaeaea;
      }
    }
  }

  &-filter {
    background: #444;

    select,
    input {
      width: 100%;
      background-color: transparent;
      border: none;
      border-bottom: solid 1px #fff;
      outline: none;
      color: #fff;
      padding: 4px 0;

      option {
        color: var(--bs-dark);
      }
    }
  }
}
</style>